import {
  MATRIX_GRID_SORTS,
  MATRIX_GRID_SORT_LABELS,
  type MatrixGridSort,
  type SortDirection,
} from '@/lib/matrix-grid-search';
import { Button, Select } from '@pms-digital/design-system';

export interface SortControlsProps {
  sort: MatrixGridSort;
  dir: SortDirection;
  onSortChange: (sort: MatrixGridSort) => void;
  onToggleDirection: () => void;
}

const SORT_OPTIONS = MATRIX_GRID_SORTS.map((value) => ({
  value,
  label: MATRIX_GRID_SORT_LABELS[value],
}));

function isSort(value: string): value is MatrixGridSort {
  return value in MATRIX_GRID_SORT_LABELS;
}

/**
 * « Trier par » (one criterion) and the button that inverts the order next to
 * it; its name says the current direction.
 */
export function SortControls({ sort, dir, onSortChange, onToggleDirection }: SortControlsProps) {
  const directionLabel =
    dir === 'desc'
      ? 'Ordre décroissant - cliquer pour inverser'
      : 'Ordre croissant - cliquer pour inverser';

  return (
    <div className="flex items-center gap-2">
      <Select
        label="Trier par"
        hideLabel
        compact
        startText="Trier par :"
        options={SORT_OPTIONS}
        value={sort}
        onValueChange={(value) => {
          if (isSort(value)) onSortChange(value);
        }}
      />
      <Button
        type="button"
        variant="field"
        size="sm"
        compact
        icon={dir === 'desc' ? 'arrow_downward' : 'arrow_upward'}
        aria-label={directionLabel}
        title={directionLabel}
        onClick={onToggleDirection}
      />
    </div>
  );
}
